export default function getAllMatches(regex, string = '', matches = []) {
  const match = regex.exec(string);
  if (!match) return matches;
  return getAllMatches(regex, string, [...matches, match]);
}
